import React, {useState} from 'react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import AccountApi from '../../logic/AccountApi'
import LoadingBackdrop from '../../components/LoadingBackdrop'
import MuiLink from '@mui/material/Link'
import {Link} from 'react-router-dom'

const api = new AccountApi()

export default function LoginHelp() {
  const [email, setEmail] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  const [emailSent, setEmailSent] = useState<boolean>(false)

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    if (loading) return

    setLoading(true)
    setError('')

    const errorMessage = 'An error occurred sending your request - please try again later'

    try {
      const res = await api.resetPasswordRequest(email)
      if (res.isError()) {
        setError(errorMessage)
      } else {
        setEmailSent(true)
      }
    } catch (err) {
      setError(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingBackdrop loading={loading}/>
      <h1>Forgot Password</h1>
      {!emailSent && <Box component="form" noValidate onSubmit={handleSubmit} sx={{mt: 3}}>
        <TextField
          value={email}
          onChange={e => {
            setError('')
            setEmail(e.target.value)
          }}
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          error={!!error}
          helperText={error}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{mt: 3, mb: 2}}>Submit</Button>
      </Box>}
      {emailSent && <Box>
        You should receive an email with a link to reset your email.
        <br/>
        <MuiLink to="/login" component={Link} style={{textDecoration: "none"}}>Go back to login</MuiLink>
      </Box>}
    </>
  )
}
